import { Formacao } from 'src/tipos'

export const SELECT_FORMACAO = Object.keys(Formacao).map(item => ({
  id: item,
  texto: Formacao[item as keyof typeof Formacao]
}))
